import BeiAn from "../general/BeiAn";
import Feedback from "../general/Feedback";

const FooterWidget = () => {
  return (
    <div>
      <div>
        <Feedback />
      </div>
      <div>
        <BeiAn />
      </div>
    </div>
  );
};

export default FooterWidget;
